module.exports = __webpack_public_path__ + "images/ranking-events-negative-review-83a4c0c5.svg";